// extracted by mini-css-extract-plugin
export default {"btn":"ButtonA_btn__7-Hac"};